// src/components/RazorpayButton.js
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createOrder, verifyPayment } from '../../../redux/paymentSlice';
import axios from 'axios';
import { toast } from 'react-toastify';

const RazorpayButton = ({ amount }) => {
  const dispatch = useDispatch();
  const { order } = useSelector((state) => state.payment);
  if (process.env.NODE_ENV === "development") {
    console.log("payemnt order", order);
  }
  const loadRazorpayScript = () =>
    new Promise((resolve) => {
      const script = document.createElement('script');
      script.src = 'https://checkout.razorpay.com/v1/checkout.js';
      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);
      document.body.appendChild(script);
    });

  const handlePayment = async () => {
    const res = await loadRazorpayScript();
    if (!res) {
      toast.error('Razorpay SDK failed to load. Check your internet connection.');
      alert('Razorpay SDK failed to load. Check your internet connection.');
      return;
    }

    await dispatch(createOrder(amount));

    const options = {
      key: process.env.REACT_APP_RAZORPAY_KEY_ID,
      amount: order?.amount,
      currency: order?.currency,
      name: 'My Store',
      description: 'Payment',
      order_id: order?.id,
      handler: async (response) => {
        await dispatch(verifyPayment({
          razorpay_order_id: response.razorpay_order_id,
          razorpay_payment_id: response.razorpay_payment_id,
          razorpay_signature: response.razorpay_signature,
        }));
        toast.success("Payment Successful");
        alert('Payment Successful');
      },
      prefill: {
        name: 'Test User',
        email: 'sonu@gmail.com',
        contact: '9876543210',
      },
      theme: { color: '#3399cc' },
    };

    const paymentObject = new window.Razorpay(options);
    paymentObject.open();
  };

  return (
    <button onClick={handlePayment} className="btn btn-success rounded">
      Pay ₹{amount}
    </button>
  );
};

export default RazorpayButton;
